var _defs, _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVitamins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 8,
    x2: 56,
    y1: 8,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF3C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDE68A"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 29,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#F97316",
    strokeWidth: 3,
    d: "M18 20h22c4 0 7 3 7 7v20c0 4-3 7-7 7H18c-4 0-7-3-7-7V27c0-4 3-7 7-7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB923C",
    d: "M22 12h14c2 0 4 2 4 4v5H18v-5c0-2 2-4 4-4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#22C55E",
    d: "M24 29h7v6h6v7h-6v6h-7v-6h-6v-7h6v-6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF4444",
    d: "M45 15c5 0 9 4 9 9 0 3-1 5-3 7L38 18c2-2 4-3 7-3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8FAFC",
    d: "m38 18 13 13c-4 4-10 4-14 0s-4-9 1-13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitamins);
export default __webpack_public_path__ + "static/media/vitamins.74295600b0016dad801a365890315683.svg";
export { ForwardRef as ReactComponent };